<template>
  <div style="padding:20px;">
    <!-- Data Stores Hack, need to be loaded first -->
    <CarwashStore ref="carwashStore"/>
    
    <PumpStatusStore ref="rcgbPumpStatusStore" location="RCGB"/>
    <PumpStatusStore ref="rmgbPumpStatusStore" location="RMGB"/>
    <PumpStatusStore ref="wgbPumpStatusStore" location="WGB"/>
    <PumpStatusStore ref="rcgbPaPumpStatusStore" location="RCGB" :isPayAtPump="true"/>
    <PumpStatusStore ref="rmgbPaPumpStatusStore" location="RMGB" :isPayAtPump="true"/>
    <PumpStatusStore ref="wgbPaPumpStatusStore" location="WGB" :isPayAtPump="true"/>
    <!-- ///////////////////////////////////////// -->
    
    <!-- Carwash - To Be Moved -->
    <Carwash />
    <!-- ///////////////////////////////////////// -->


    
    <h1>Pump Status</h1>
    <p><strong>Note:</strong>Refreshes every 10 seconds.</p>

    <div v-for=" name in ['rcgb','rcgbPa','rmgb','rmgbPa','wgb','wgbPa',]" :key="name">
      <PumpStatus :storeName="`${name}PumpStatusStore`" /> <br />
    </div>
  
    <br>
  </div>
</template>

<script>
import PumpStatusStore from './Stores/PumpStatusStore.vue'
import PumpStatus from './Components/PumpStatus.vue'
import CarwashStore from './Stores/CarwashStore.vue'
import Carwash from './Components/Carwash.vue'
export default {
  name: 'PumpStatusPage',
  components:{PumpStatus, PumpStatusStore, Carwash, CarwashStore},
  provide(){
    return {
      pumpStatusPage: this,
    }
  },
  data () { return { 
    } 
  },
}
</script>

<style>
</style>
